import React from "react";
import EditButton from "../buttons/EditButton";
import BudgetCard from "./BudgetCard";
import {getDifferenceBetweenTwoNumber, getPercent, getReversePercent} from "../../utils/utils";
import {useSelector} from "react-redux";
import styled from "styled-components";
import {
    BudgetAndTimeContainer,
    NameSectionBudgetAndTime as NameSection,
    WrapperBudgetAndTime
} from "../styles/styles";

const Budget = ({
                    setOpenEditModal,
                    openEditBudgetModal,
                    type
                }) => {

    const {estimatedInvestmentBudget, realInvestmentBudget, estimatedExploitationBudget, realExploitationBudget,isBudgetOptional} = useSelector(state => state.project)

    return (
        <Container>
            <NameSection>
                <h2> Budgets </h2>
                {!openEditBudgetModal &&
                <EditButton
                    setUpdate={setOpenEditModal}
                    data={openEditBudgetModal}
                />
                }
            </NameSection>
            {isBudgetOptional ?
                <p> L'estimation de budget n'est pas activée pour ce projet </p>
                :
                <Wrapper>

                    <LargeContainer>
                        <BudgetCard
                            name={"estimated"}
                            title={"investissement Réel"}
                            total={realInvestmentBudget}
                            percent={getPercent(estimatedInvestmentBudget, realInvestmentBudget)}
                        />
                        <BudgetCard
                            name={"real"}
                            title={"Investissement Prévisionnel"}
                            total={estimatedInvestmentBudget}
                        />
                    </LargeContainer>
                    <LargeContainer>
                        <BudgetCard
                            name={"estimated"}
                            title={"Exploitation Réel"}
                            total={realExploitationBudget}
                            percent={getPercent(estimatedExploitationBudget, realExploitationBudget)}
                        />
                        <BudgetCard
                            name={"real"}
                            title={"Exploitation Prévisionnel"}
                            total={estimatedExploitationBudget}
                        />
                    </LargeContainer>
                    <BudgetCard
                        name={"balance"}
                        title={"Balance investissement"}
                        total={getDifferenceBetweenTwoNumber(estimatedInvestmentBudget, realInvestmentBudget)}
                        percent={getReversePercent(estimatedInvestmentBudget, realInvestmentBudget)}
                    />
                    <BudgetCard
                        name={"balance"}
                        title={"Balance Exploitation"}
                        total={getDifferenceBetweenTwoNumber(estimatedExploitationBudget, realExploitationBudget)}
                        percent={getReversePercent(estimatedExploitationBudget, realExploitationBudget)}
                    />
                    <BudgetCard
                        name={"balance"}
                        title={"Balance totale"}
                        total={getDifferenceBetweenTwoNumber((estimatedExploitationBudget + estimatedInvestmentBudget), (realExploitationBudget + realInvestmentBudget))}
                        percent={getReversePercent((estimatedExploitationBudget + estimatedInvestmentBudget), (realExploitationBudget + realInvestmentBudget))}
                    />
                </Wrapper>

            }
        </Container>
    )
}

const Container = styled(BudgetAndTimeContainer)`
  height: 100%;
  padding: 1rem;
  width: 100%;
  align-items:center;

`
const Wrapper = styled(WrapperBudgetAndTime)`
  flex-direction: column;
  //background: yellow;
`
const LargeContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  height: 40%;
  justify-content: center;
  align-items: center;
  gap: 1em;
  
`

export default Budget;